// Stuffed ids are kept under their own key. They come from a different
// table than live surplus ids, so mixing them would make /surplus-by-id
// and /stuffed-by-id read the wrong record.
export const STUFFED_KEY = "requestedStuffedIds";

export const addStuffedId = (id) => {
  const asString = String(id);
  const stored = sessionStorage.getItem(STUFFED_KEY);
  const current = stored ? stored.split(",") : [];
  if (current.indexOf(asString) === -1) {
    current.push(asString);
  }
  const next = current.join(",");
  sessionStorage.setItem(STUFFED_KEY, next);
  return next;
};

export const removeStuffedId = (id) => {
  const asString = String(id);
  const stored = sessionStorage.getItem(STUFFED_KEY);
  const current = stored ? stored.split(",") : [];
  const next = current.filter((entry) => entry !== asString);
  if (next.length === 0) {
    sessionStorage.removeItem(STUFFED_KEY);
    return null;
  }
  sessionStorage.setItem(STUFFED_KEY, next.join(","));
  return next.join(",");
};
